export default __webpack_public_path__ + "eaae522ea07ced4210f5a585859757a6.png";